require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-reasonml-in-browser.json") })
        }
      }, "path---package-reasonml-in-browser");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-reasonml-in-browser!./.cache/json/package-reasonml-in-browser.json
// module id = 911
// module chunks = 231608221292675